import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {CHANNEL_INFO_BY_CHANNEL} from '../channels/channels';
import {FaIcon} from '../FaIcon';
import './ReportContextSelector.scss';


const CHANNEL_COLOR_MAP = {
    GOOGLE: '#1AA85D',
    FACEBOOK: '#3B5998',
    TIKTOK: '#000000',
    LINKEDIN: '#0A66C2',
    ANALYTICS: '#E7B042',
    SHEET: '#cc9250',
    SHOPIFY: '#96BF48',
    TIENDA_NUBE: '#28a7e9',
};

export const ReportContextSelector = ({template, adAccounts, businessUnits, onScopeChange}) => {
    const {t} = useTranslation();
    const [selectedItemId, setSelectedItemId] = useState(null);

    if (!template || !template.allows_item_selection) {
        return null;
    }

    const isAdAccounts = template.data_source_level === 'AD_ACCOUNTS';
    const items = isAdAccounts ? (adAccounts || []) : (businessUnits || []);

    const handleSelect = (itemId) => {
        setSelectedItemId(itemId);
        if (onScopeChange) {
            onScopeChange({
                data_source_type: template.data_source_level,
                ad_account_id: isAdAccounts ? itemId : null,
                business_unit_id: !isAdAccounts ? itemId : null,
            });
        }
    };

    return (
        <div className="report-context-selector">
            <div className="report-context-selector__info">
                <FaIcon iconName={isAdAccounts ? 'bullhorn' : 'chart-pie'}/>
                <span>{isAdAccounts ? t('reports.context_ad_accounts_info') : t('reports.context_bus_info')}</span>
            </div>

            <div className="report-context-selector__label">
                {t('reports.context_select_item')}
            </div>

            <div className="report-context-selector__options">
                <div
                    className={`report-context-selector__option ${selectedItemId === null ? '-selected' : ''}`}
                    onClick={() => handleSelect(null)}
                >
                    <span className="report-context-selector__option-text">
                        {isAdAccounts ? t('reports.context_all_accounts') : t('reports.context_all_bus')}
                    </span>
                    {selectedItemId === null && (
                        <FaIcon iconName="circle-check" className="report-context-selector__option-check"/>
                    )}
                </div>
                {items.map(item => {
                    const isSelected = selectedItemId === item.id;
                    if (isAdAccounts) {
                        const channelInfo = CHANNEL_INFO_BY_CHANNEL[item.channel];
                        const channelName = channelInfo ? channelInfo.Spanish : item.channel;
                        const dotColor = CHANNEL_COLOR_MAP[item.channel] || '#999';
                        return (
                            <div
                                key={item.id}
                                className={`report-context-selector__option ${isSelected ? '-selected' : ''}`}
                                onClick={() => handleSelect(item.id)}
                            >
                                <span
                                    className="report-context-selector__channel-dot"
                                    style={{backgroundColor: dotColor}}
                                ></span>
                                <span className="report-context-selector__option-text">
                                    {channelName} - {item.name}
                                </span>
                                {isSelected && (
                                    <FaIcon iconName="circle-check" className="report-context-selector__option-check"/>
                                )}
                            </div>
                        );
                    }
                    return (
                        <div
                            key={item.id}
                            className={`report-context-selector__option ${isSelected ? '-selected' : ''}`}
                            onClick={() => handleSelect(item.id)}
                        >
                            <span className="report-context-selector__option-text">
                                {item.name}
                            </span>
                            {isSelected && (
                                <FaIcon iconName="circle-check" className="report-context-selector__option-check"/>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
